import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const BLUE = "#1565C0";
const BORDER = "#e2e8f0";
const TEXT = "#0f172a";
const MUTED = "#64748b";

const DailyBookDetail = ({ asiento, money }) => {
  const detalles = asiento.detalles || [];
  const debe = detalles.filter((item) => Number(item.debe || 0) > 0);
  const haber = detalles.filter((item) => Number(item.haber || 0) > 0);

  const AccountLine = ({ item, side }) => {
    const value = side === "debe" ? item.debe : item.haber;

    return (
      <Box
        sx={{
          borderBottom: `1px solid ${BORDER}`,
          py: 1.1,
          display: "grid",
          gridTemplateColumns: "1fr auto",
          gap: 1.5,
          alignItems: "start",
          "&:last-of-type": {
            borderBottom: "none",
          },
        }}
      >
        <Box>
          <Typography sx={{ fontSize: 14, fontWeight: 700, color: TEXT }}>
            {item.cuenta_codigo}
          </Typography>

          <Typography sx={{ fontSize: 13, fontWeight: 600, color: TEXT }}>
            {item.cuenta_nombre}
          </Typography>

          {item.descripcion && (
            <Typography sx={{ fontSize: 12, fontWeight: 500, color: MUTED, mt: 0.2 }}>
              {item.descripcion}
            </Typography>
          )}
        </Box>

        <Typography sx={{ fontSize: 14, fontWeight: 800, color: TEXT }}>
          ${money(value)}
        </Typography>
      </Box>
    );
  };

  return (
    <Box sx={{ bgcolor: "#f8fafc", px: 2, py: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              border: `1px solid ${BORDER}`,
              borderRadius: 2,
              bgcolor: "#ffffff",
              overflow: "hidden",
            }}
          >
            <Box sx={{ bgcolor: BLUE, color: "#ffffff", px: 2, py: 1 }}>
              <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                Debe
              </Typography>
            </Box>

            <Box sx={{ px: 2 }}>
              {debe.length === 0 && (
                <Typography sx={{ py: 2, color: MUTED, fontWeight: 700 }}>
                  Sin valores en debe.
                </Typography>
              )}

              {debe.map((item) => (
                <AccountLine key={item.id} item={item} side="debe" />
              ))}
            </Box>

            <Box
              sx={{
                borderTop: `1px solid ${BORDER}`,
                px: 2,
                py: 1,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontWeight: 700 }}>Total debe</Typography>
              <Typography sx={{ fontWeight: 800 }}>${money(asiento.total_debe)}</Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            sx={{
              border: `1px solid ${BORDER}`,
              borderRadius: 2,
              bgcolor: "#ffffff",
              overflow: "hidden",
            }}
          >
            <Box sx={{ bgcolor: BLUE, color: "#ffffff", px: 2, py: 1 }}>
              <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                Haber
              </Typography>
            </Box>

            <Box sx={{ px: 2 }}>
              {haber.length === 0 && (
                <Typography sx={{ py: 2, color: MUTED, fontWeight: 700 }}>
                  Sin valores en haber.
                </Typography>
              )}

              {haber.map((item) => (
                <AccountLine key={item.id} item={item} side="haber" />
              ))}
            </Box>

            <Box
              sx={{
                borderTop: `1px solid ${BORDER}`,
                px: 2,
                py: 1,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontWeight: 700 }}>Total haber</Typography>
              <Typography sx={{ fontWeight: 800 }}>${money(asiento.total_haber)}</Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: 2,
          border: `1px solid ${BORDER}`,
          borderRadius: 2,
          bgcolor: "#ffffff",
          px: 2,
          py: 1.5,
        }}
      >
        <Grid container spacing={1.5}>
          <Grid item xs={12} md={4}>
            <Typography sx={{ fontSize: 12, color: MUTED, fontWeight: 700 }}>
              Descripción
            </Typography>
            <Typography sx={{ fontSize: 13, color: TEXT, fontWeight: 700 }}>
              {asiento.descripcion || "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography sx={{ fontSize: 12, color: MUTED, fontWeight: 700 }}>
              Creado por
            </Typography>
            <Typography sx={{ fontSize: 13, color: TEXT, fontWeight: 700 }}>
              {asiento.creado_por || "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography sx={{ fontSize: 12, color: MUTED, fontWeight: 700 }}>
              Creado en
            </Typography>
            <Typography sx={{ fontSize: 13, color: TEXT, fontWeight: 700 }}>
              {asiento.creado_en || "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={2}>
            <Typography sx={{ fontSize: 12, color: MUTED, fontWeight: 700 }}>
              Estado
            </Typography>
            <Typography sx={{ fontSize: 13, color: TEXT, fontWeight: 700 }}>
              {asiento.estado_label || asiento.estado || "-"}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default DailyBookDetail;